export default class PasswordChecker {
  /**
   * パスワードの強度判定用のクラス
   * @param {String} input - パスワード文字列
   */
  constructor(input) {
    this.input = input || ''
    this.pattern = 0
    this.strength = 0
    this.hasLower = 0
    this.hasUpper = 0
    this.hasCharacter = 0
    this.hasNumber = 0
  }

  /**
   * 入力された文字列にたいして文字パターン数を返す
   **/
  getPattern() {
    this.pattern = 0
    this.hasLower = 0
    this.hasUpper = 0
    this.hasCharacter = 0
    this.hasNumber = 0

    /**
     * 特殊文字かどうかを判定する
     * @param {charCode} ユニコード値
     * @return {boolean}
     */
    const isSpecialCharacter = charCode => {
      return (
        (charCode >= 33 && charCode <= 47) ||
        (charCode >= 58 && charCode <= 64) ||
        (charCode >= 91 && charCode <= 96) ||
        (charCode >= 123 && charCode <= 126)
      )
    }

    Array.prototype.slice.call(this.input).forEach(char => {
      let ascii = char.charCodeAt(0)

      //アルファベット小文字チェック
      this.hasLower += ascii >= 97 && ascii <= 122 ? 1 : 0

      //アルファベット大文字チェック
      this.hasUpper += ascii >= 65 && ascii <= 90 ? 1 : 0

      //数値チェック
      this.hasNumber += ascii >= 48 && ascii <= 57 ? 1 : 0

      //記号チェック
      this.hasCharacter += isSpecialCharacter(ascii) == true ? 1 : 0
    })

    //パターン判別
    this.pattern += this.hasLower > 0 ? 1 : 0
    this.pattern += this.hasUpper > 0 ? 1 : 0
    this.pattern += this.hasNumber > 0 ? 1 : 0
    this.pattern += this.hasCharacter > 0 ? 1 : 0
    
    return this.pattern
  }

  /**
   * パスワード強度の判定
   * @return {Number} 0 ~ 4 の数値で強度を判定する
   **/
  getStrength() {
    const pattern = this.getPattern()

    // 文字列の長さとパターンでパスワードの強度を判定する
    const inputLength = this.input.length

    if (inputLength > 0 && inputLength < 8) {
      this.strength = 1
    }

    if (inputLength >=8 && inputLength < 12) {
      this.strength = 2
    }

    if (inputLength >= 8 && inputLength < 12 && pattern >= 2) {
      this.strength = 3
    }

    if (inputLength >= 8 && inputLength < 12 && pattern >= 3) {
      this.strength = 4
    }

    if (inputLength >= 12 && pattern < 3) {
      this.strength = 4
    }

    if (inputLength >= 12 && pattern >= 3) {
      this.strength = 5
    }

    if (inputLength === 0 || inputLength > 30) {
      this.strength = 0
    }

    //全角文字チェック
    if(/(?=.*[^\x01-\x7E\uFF61-\uFF9F]).+$/g.test(this.input)){
      this.strength = 0
    }

    //特殊系：半角カナ、スペース文字チェック
    if(/(?=.*[ｦ-ﾟ]|[\s]).+$/g.test(this.input)){
      this.strength = 0
    }

    //半角の英大文字、英小文字、数字の組み合わせチェック
    // if (/^(?!.*?(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[0-9a-zA-Z\-]).+$/.test(this.input)) {
    //   this.strength = 0
    // }

    //半角英、数字の組み合わせチェック（大文字小文字は問わない）
    if(/^(?!.*?(?=.*?[a-z])(?=.*?\d)).+$/i.test(this.input)){
      this.strength = 0
    }

    //辞書に登録されている文字チェック
    const dictionary = ['password', 'qwerty', 'abc', 'admin', 'root', '123']
    dictionary.forEach(word => {
      if (this.input.toLowerCase().indexOf(word) != -1) {
        //this.strength = 0
      }
    })

    return this.strength
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/utvStore/components/forms/PasswordChecker.js